import { FC } from 'react'
import Link from 'next/link'
import { sanitizeUrl } from '@/utils'
import { Avatar2 } from '@components-v2/atoms/Avatar2'
import classNames from 'classnames'
import { VerifiedTick } from '@components-v2/atoms/VerifiedTick'
import styles from './index.module.scss'

type Props = {
  src: string
  title: string
  subtitle: string
  supportingText?: string
  href?: string
  size?: 'small' | 'medium' | 'large'
  withVerifiedTick?: boolean
}

/**
 * Figma で job card という名前の ui component
 */
export const AvatarTextCard: FC<Props> = ({
  src,
  title,
  subtitle,
  supportingText,
  href,
  size = 'medium',
  withVerifiedTick = false,
}) => {
  const content = (
    <div className={styles.card}>
      <div className={styles.heading}>
        <div className={styles.logo}>
          <Avatar2 src={src} alt={title} size='lg' />
          {withVerifiedTick && (
            <div className={styles.verifiedTick}>
              <VerifiedTick size='sm' />
            </div>
          )}
        </div>
        <div className={styles.title}>
          <div className={styles.title__main}>{title}</div>
          <div className={styles.title__sub}>{subtitle}</div>
        </div>
      </div>
      {supportingText && <div className={styles.supportingText}>{supportingText}</div>}
    </div>
  )

  if (href) {
    return (
      <Link href={sanitizeUrl(href)}>
        <a
          className={classNames(styles.container, {
            [styles.small]: size === 'small',
            [styles.medium]: size === 'medium',
            [styles.large]: size === 'large',
          })}
        >
          {content}
        </a>
      </Link>
    )
  }

  return (
    <div
      className={classNames(styles.container, {
        [styles.small]: size === 'small',
        [styles.medium]: size === 'medium',
        [styles.large]: size === 'large',
      })}
    >
      {content}
    </div>
  )
}
